/* eslint-disable */
/**
 * JD登录组件，不依赖任何框架，可以在vue,react等框架下使用，基于原生操作
 * 使用方法：
 * （1）在总入口的地方引入：import './login.js';
 * （2）初始化登录状态：请在总入口的地方调用(要在任何后台API之前调用)jdLoginTools_create_by_team_aris.initLoginState(options--登录配置);
 * （3）初始化登录窗口：window.jdLoginTools_create_by_team_aris.initLoginForm(dom--登录窗口容器原生dom元素, options--登录配置)
 * （4）初始化退出按钮：logoutButtonDom.addEventListener('click', function() { window.jdLoginTools_create_by_team_aris.logout(options--登录配置); })
 * （5）登录配置：{
 *    // 选填----你的系统使用的协议https还是http
 *    protocol: 'https',
 *    // 选填----默认空字符串：ERP和JDPIN两种登录方式。ERP: 只有ERP一种登录方式。JDPIN：只有JDPIN一种登录方式。
 *    onlyOneLoginType: '',
 *    // 必填----登录类型： ERP、JDPIN
 *    loginType: 'JDPIN',
 *    // 选填----JDPIN登录按钮的样式配置码，passport.jd.com里面会根据这个参数设置对应的按钮样式
 *    btnTag: '3f27ccc4f27be804',
 *    // 必填----这个参数是在JDPIN登录时候需要的，请向erp: fenghao18,那边申请个自己应用的ID
 *    from: '',
 *    // 必填----登录页面的URL, 可以不需要带协议和域名
 *    loginUrl: '',
 *  }
 */
 (function() {
  var logoutIframe;
  var logcount = 0;
  // 用户更新的配置
  var mergedOptions;
  // 默认配置
  var defaultOptions = mergedOptions = {
    // 选填----你的系统使用的协议https还是http
    protocol: 'https',
    // 选填----默认空字符串：ERP和JDPIN两种登录方式。ERP: 只有ERP一种登录方式。JDPIN：只有JDPIN一种登录方式。
    onlyOneLoginType: '',
    // 必填----登录类型： ERP、JDPIN
    loginType: 'JDPIN',
    // 选填----JDPIN登录按钮的样式配置码，passport.jd.com里面会根据这个参数设置对应的按钮样式
    btnTag: '3f27ccc4f27be804',
    // 必填----这个需要向passport.jd.com那边申请个自己应用的ID
    from: '',
    // 必填----登录页面的URL, 可以不需要带协议和域名
    loginUrl: '',
  };
  // 登录组件的状态
  var states = {
    // 0: 未加载页面， 1: 代表账号密码或者JIN密扫码登录， 2：代表账号密码登录之后，还需扫码再验证阶段
    step: 0,
    // 0： 代表iframe内的URL页面还未加载完成，1:代表iframe内的页面已经完成加载
    logcount
  };
  /**
   * 获取登录之后需要跳转的url
   */
  function getReturnUrl() {
    // 如果是登录界面
    if (url('path', mergedOptions.loginUrl) === location.pathname) {
      return getUrlParam('returnUrl') || encodeURIComponent(location.protocol + '//' + location.host);
    } else {
      return encodeURIComponent(location.href);
    }
  }
  /**
   * 获取去JD登录认证页面的URL
   */
  function getLinkLogin(options) {
    var returnUrl = getReturnUrl();
    if (options.loginType == 'ERP') {
      return options.protocol + '://ssa.jd.com/sso/login?ReturnUrl=' + returnUrl;
    } else {
      return options.protocol + '://passport.jd.com/common/loginPage?btnTag=' + options.btnTag + '&from=' + options.from + '&ReturnUrl=' + returnUrl;
    }
  }
  /**
   * 获取切换EPR或者JDPIN的登录认证页面的URL
   */
  function switchLoginType(options) {
    var oldUrl = getUrlParam('returnUrl') || encodeURIComponent(location.protocol + '//' + location.host);
    var type = options.loginType == 'JDPIN' ? 'erp' : 'jdpin';
    var re = /(logintype%3D)([^&]*)/gi;
    oldUrl = oldUrl.replace(re, 'logintype%3D' + type);
    if (oldUrl.indexOf('logintype%3D') === -1) {
      oldUrl += (oldUrl.indexOf('%3F') == -1 ? '%3F' : '%26') + 'logintype%3D' + type;
    }
    return location.protocol + '//' + location.host + options.loginUrl + '?logintype=' + type + '&ReturnUrl=' + oldUrl;
  }
  // iframe内的登录加载之后有时候iframe中加载的京东PIN和ERP登录页面无法显示，原因未知。
  function loginFrameOnload() {
    // if (window.self === window.top && Cookie.getCookie('sso.jd.com')) {
    //   createLoadingDom();
    // }
    var loginForm = $.id('jdLoginTools_create_by_team_aris_domId_loginForm');
    if (mergedOptions.loginType == 'ERP') {
      $.removeClass(loginForm, 'login-conter-erp-step' + states.step);
    }
    states.step ++;
    // 登录密码错误，回归第一步
    // if (!Cookie.getCookie("sso.jd.com")) {
    //   states.step = 1;
    // }
    if (mergedOptions.loginType == 'ERP') {
      $.addClass(loginForm, 'login-conter-erp-step' + states.step);
    }
    $.addClass(loginForm, "loginForm_fix_nodisplay_bug");
    setTimeout(function() { $.removeClass(loginForm, "loginForm_fix_nodisplay_bug"); }, 10);
  }
  function mergedOptionsFunc(options) {
    var logintype = options.loginType.toLowerCase() || getUrlParam('logintype') || window.sessionStorage.getItem('logintype');
    if (logintype) {
      options.loginType = logintype.toUpperCase();
    } else {
      logintype = 'erp';
      options.loginType = 'ERP';
    }
    mergedOptions = Object.assign(defaultOptions, options);
  }
  /**
   * 初始化登录参数和设置页面登录状态，如果已经登录，就跳转等
   * @param options 登录配置选项，具体参考defaultOptions对象
   */
  function initLoginState(options) {
    mergedOptionsFunc(options);
    var logintype = mergedOptions.loginType.toLowerCase();
    window.sessionStorage.setItem('logintype', logintype);
    //if (logintype === 'erp') {
      // var ticket = Cookie.getCookie("sso.jd.com") || '';
      // Cookie.setCookie("ticket", ticket);
    //} else {
      // 这里删除不起作用
      // Cookie.delCookie("sso.jd.com");
      // Cookie.delCookie("ticket");
    //}
    // 检查是否是ERP账号iframe已经登录了，如果是，则让其父级跳转到非登录页面
    // if (window.self != window.top) {
    //   createLoadingDom();
    //   const ticket = Cookie.getCookie('ticket');
    //   setTimeout(() => {
    //     if (
    //       // @ts-ignore
    //       window.parent.location.pathname === url('path', mergedOptions.loginUrl) &&
    //       // @ts-ignore
    //       ticket &&
    //       document.referrer === mergedOptions.protocol + '://ssa.jd.com/'
    //     ) {
    //       window.parent.location.href = window.location.href;
    //     } else if (
    //       // @ts-ignore
    //       !ticket &&
    //       window.top.location.pathname === window.location.pathname &&
    //       // @ts-ignore
    //       window.location.pathname === url('path', mergedOptions.loginUrl)
    //     ) {
    //       window.top.location.reload();
    //     }
    //   }, 2000);
    // }
  }
  /**
   * 初始化登录表单函数
   * @param dom 登录窗口的容器DOM（原生）
   * @param options 登录配置选项，具体参考defaultOptions对象
   */
  function initLoginForm(dom, options) {
    $.addStyleToHead('jdLoginTools_create_by_team_aris_style', loginCss);
    mergedOptionsFunc(options);
    $.addClass(dom, 'jdLoginTools_create_by_team_aris_css');
    var loginHtml =
      '<div class="loginForm' + (mergedOptions.loginType == 'ERP' ? ' erp login-conter-erp-step' + states.step : ' jdpin') + '" id="jdLoginTools_create_by_team_aris_domId_loginForm">' +
        '<div class="right-text-header">' + (mergedOptions.loginType == 'ERP' ? ' ERP账号登录' : '京东账号登录') + '</div>' + 
      
        (mergedOptions.loginType == 'ERP' ? '<a class="login-conter" href="'+getLinkLogin(mergedOptions)+'">立即登录</a>' : '<iframe scrolling="no" src="' + getLinkLogin(mergedOptions) + '" class="login-conter" id="jdLoginTools_create_by_team_aris_domId_loginFrame"></iframe>') +

          '<div class="erp-step2-hidden-1"></div>' +
        '<div class="erp-step2-hidden-2"></div>' +
      '</div>';
    if (mergedOptions.onlyOneLoginType === '') {
      if (mergedOptions.loginType == 'ERP') {
        loginHtml +=
          '<div class="switchLoginType">' +
            '<div>当前为京东ERP账号登录</div>' +
            '<a class="a_switchLoginType" href="javascript:void(0);">切换京东账号登录 ></a>' +
          '</div>';
      } else {
        loginHtml +=
          '<div class="switchLoginType">' +
            '<div>当前为京东账号登录</div>' +
            '<a class="a_switchLoginType" href="javascript:void(0);">切换京东ERP账号登录 ></a>' +
          '</div>';
      }
    }
    loginHtml += '</div>';
    dom.innerHTML = loginHtml;
    dom.querySelector('iframe') && (dom.querySelector('iframe').onload = loginFrameOnload);
    var switchBtn = dom.querySelector('.a_switchLoginType');
    if (switchBtn) {
      switchBtn.onclick = function(e) {
        e.target.setAttribute('disabled', true);
        logout(mergedOptions, function() {
          window.location.href = switchLoginType(mergedOptions);
        });
      };
    }
    if (mergedOptions.loginType == 'ERP') {
      var Sys = $.getBrowserInfo();
      if (Sys.browser === 'firefox' && Sys.ver < 90) {
        myAlert({
          title: '系统提示',
          content: '您的浏览器版本太低~，请升级后再登录' + (mergedOptions.onlyOneLoginType === 'ERP' ? '!' : '或者您不想升级，可以<a style="color:#1e88e5;" href="' + switchLoginType(mergedOptions) + '">切换到JD账号登录</a>！'),
        });
      }
    }
  }
  /**
   * 当iframe内部退出后，消除了cookie内的登录信息后，此回调函数将页面跳转到应用的登录页面。
   */
  function logoutDefaultCB() {
    logcount++;
    $.tagName('body')[0].removeChild(logoutIframe);
    if (logcount == 1) {
      window.location.href = addParamToUrlStr(mergedOptions.loginUrl, 'returnUrl', getReturnUrl());
    }
  }
  /**
   * 初始化退出按钮
   * @param options 登录配置选项，具体参考defaultOptions对象
   */
  function logout(options, logoutCB) {
    mergedOptions = Object.assign(defaultOptions, options);
    var lastLoginType = window.sessionStorage.getItem('logintype');
    if (lastLoginType) {
      mergedOptions = Object.assign(mergedOptions, {
        loginType: lastLoginType.toUpperCase()
      });
    }
    var returnUrl = getReturnUrl();
    logoutIframe = document.createElement('iframe');
    logoutIframe.style = 'position:absolute;top:-10000px;left:-10000px;';
    logoutIframe.onload = logoutCB || logoutDefaultCB;
    if (mergedOptions.loginType == 'ERP') {
      logoutIframe.src = mergedOptions.protocol + '://ssa.jd.com/sso/logout?ReturnUrl=' + returnUrl;
    } else {
      logoutIframe.src = mergedOptions.protocol + '://passport.jd.com/uc/login?ltype=logout&ReturnUrl=' + returnUrl;
    }
    $.tagName('body')[0].appendChild(logoutIframe);
  }
  // 全局
  window.jdLoginTools_create_by_team_aris = {
    initLoginState: initLoginState,
    initLoginForm: initLoginForm,
    logout: logout
  };
  function myAlert(config) {
    var popWin = document.getElementById('jdLoginTools_create_by_team_aris_modal-window');
    if (!popWin) {
      popWin = document.createElement('div')
      popWin.id = 'jdLoginTools_create_by_team_aris_modal-window';
      popWin.innerHTML = 
        '<div class="jdLoginTools_create_by_team_aris_modal-popWin">' +
          '<a href="#" title="Close" class="jdLoginTools_create_by_team_aris_modal-close">Close</a>' +
          '<div class="jdLoginTools_create_by_team_aris_modal-title">' + config.title + '</div>' +
          config.content
        '</div>';
      popWin.querySelector('.jdLoginTools_create_by_team_aris_modal-close').onclick = function(e) {
        popWin.className = 'jdLoginTools_create_by_team_aris_modal-window';
      };
      document.body.appendChild(popWin);
    }
    popWin.className = 'jdLoginTools_create_by_team_aris_modal-window jdLoginTools_create_by_team_aris_modal-window-visible';
  }
  function createLoadingDom() {
    var loginFrame = window.parent.document.getElementById('jdLoginTools_create_by_team_aris_domId_loginFrame');
    loginFrame.style.cssText = 'margin-top:57px;height:383px;';
    
    var loading = document.createElement('div');
    var loadingWrap = document.createElement('div');
    var loadingImg = document.createElement('img');
    var loadingTxt = document.createElement('div');
    loading.id = 'jdLoginTools_create_by_team_aris_domId_loading';
    loadingImg.src = 'data:image/gif;base64,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';
    loadingTxt.innerText = '正在加载...';
    loading.style.cssText = `position:fixed;top:0;bottom:0;left:0;right:0;z-index:1000000000000;background:#fff;`;
    loadingWrap.style.cssText = `position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);`;
    loadingImg.style.cssText = `display:block;margin:auto;width:50px;height:50px;`;
    loadingTxt.style.cssText = `text-align:center;margin-top:10px;`;
    loadingWrap.appendChild(loadingImg);
    loadingWrap.appendChild(loadingTxt);
    loading.appendChild(loadingWrap);
    document.body.appendChild(loading);
  }
  function getUrlParam(name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    var r = window.location.search.substr(1).match(reg);
    if (r != null) return decodeURI(r[2]);
    return null;
  }

  function addParamToUrlStr(url, name, value) {
    var newUrl = "";
    var reg = new RegExp("(^|)" + name + "=([^&]*)(|$)");
    var tmp = name + "=" + value;
    if (url.match(reg) != null) {
      newUrl = url.replace(eval(reg), tmp);
    } else {
      if (url.match("[\?]")) {
        newUrl = url + "&" + tmp;
      } else {
        newUrl = url + "?" + tmp;
      }
    }
    return newUrl;
  }
  var $ = {
    id: function(id) {
      return document.getElementById(id);
    },
    tagName: function(name) {
      return document.getElementsByTagName(name);
    },
    hasClass: function(elements, cName) {
      return !!elements.className.match(new RegExp("(\\s|^)" + cName + "(\\s|$)"));
    },
    addClass: function(elements, cName) {
      if (!this.hasClass(elements, cName)) {
        elements.className += " " + cName;
      }
    },
    removeClass: function(elements, cName) {
      if (this.hasClass(elements, cName)) {
        elements.className = elements.className.replace(new RegExp("(\\s|^)" + cName + "(\\s|$)"), " ");
      }
    },
    /**
     * [addCssByStyle 动态添加页面css样式表]
     * @param  {[type]} id [style元素的id,不能和其他重复必须唯一，必填]
     * @param  {[type]} cssString [样式表字符串，必填]
     * @return {[type]}      [无]
     */
    addStyleToHead: function(id, cssString) {
      var doc = document;
      var styleTagId = "style_" + id;
      var lastStyle = doc.getElementById(styleTagId);
      var heads = doc.getElementsByTagName("head");
      if (lastStyle) {
        if (heads.length) heads[0].removeChild(lastStyle);
        else doc.documentElement.removeChild(lastStyle);
      }
      var style = doc.createElement("style");
      style.setAttribute("id", styleTagId);
      style.setAttribute("type", "text/css");

      if (style.styleSheet) {
        // IE
        style.styleSheet.cssText = cssString;
      } else {
        // w3c
        var cssText = doc.createTextNode(cssString);
        style.appendChild(cssText);
      }
      if (heads.length) heads[0].appendChild(style);
      else doc.documentElement.appendChild(style);
    },
    getBrowserInfo: function() {
      var Sys = {};
      var ua = navigator.userAgent.toLowerCase();
      var re = /(msie|firefox|chrome|opera|version).*?([\d.]+)/;
      var m = ua.match(re);
      Sys.browser = m[1].replace(/version/, "'safari");
      try {
        Sys.ver = Number(m[2]);
      } catch(e){
        Sys.ver = 0;
      }
      return Sys;
    }
  };

  var eventTool = {
    addEventListener: function(element, type, fn) {
      if (element.addEventListener) {
        element.addEventListener(type, fn, false);
      }
      else if(element.attachEvent) {
        element.attachEvent("on" + type, fn);
      } else {
        element["on" + type] = fn;
      }
    },
    removeEventListener: function(element, type, fnName) {
      if (element.removeEventListener) {
        element.removeEventListener(type, fnName, false);
      }
      else if(element.detachEvent) {
        element.detachEvent("on" + type, fnName);
      } else {
        element["on" + type] = null;
      }
    }
  };
  var Cookie = {
    // 获取cookie、
    getCookie(name) {
      const reg = new RegExp(`(^| )${name}=([^;]*)(;|$)`);
      const arr = document.cookie.match(reg);
      if (arr) {
        return decodeURIComponent(arr[2]);
      }
      return null;
    },
  
    // 设置cookie
    setCookie(c_name, value, expiredays) {
      const exdate = new Date();
      // @ts-ignore
      exdate.setDate(exdate.getDate() + expiredays);
      document.cookie = `${c_name}=${encodeURIComponent(value)}${
        // @ts-ignore
        expiredays == null ? '' : `;expires=${exdate.toGMTString()}`
      };path=/;domain=.jd.com`;
    },
  
    // 删除cookie
    delCookie(name) {
      const exp = new Date();
      exp.setTime(exp.getTime() - 1);
      const cval = Cookie.getCookie(name);
      // @ts-ignore
      document.cookie = `${name}=${cval};expires=${exp.toGMTString()};path=/`;
    },
  };
  var loginCss = `
.jdLoginTools_create_by_team_aris_modal-window {
  font: 600 18px/1.5 -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
  position: fixed;
  background-color: rgba(255, 255, 255, 0.25);
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 999;
  visibility: hidden;
  opacity: 0;
  pointer-events: none;
  transition: all 0.3s;
}
.jdLoginTools_create_by_team_aris_modal-window.jdLoginTools_create_by_team_aris_modal-window-visible {
  visibility: visible;
  opacity: 1;
  pointer-events: auto;
}
.jdLoginTools_create_by_team_aris_modal-window .jdLoginTools_create_by_team_aris_modal-popWin {
  width: 400px;
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  padding: 2em;
  background: #ffffff;
  border-radius:5px;
  box-shadow: 0 1px 3px rgb(0 0 0 / 30%);
}
.jdLoginTools_create_by_team_aris_modal-window header {
  font-weight: bold;
}
.jdLoginTools_create_by_team_aris_modal-window .jdLoginTools_create_by_team_aris_modal-title {
  font-size: 150%;
  margin: 0 0 15px;
}
.jdLoginTools_create_by_team_aris_modal-close {
  color: #aaa;
  line-height: 50px;
  font-size: 80%;
  position: absolute;
  right: 0;
  text-align: center;
  top: 0;
  width: 70px;
  text-decoration: none;
}
.jdLoginTools_create_by_team_aris_modal-close:hover {
  color: black;
}
.jdLoginTools_create_by_team_aris_modal-window div:not(:last-of-type) {
  margin-bottom: 15px;
}
.jdLoginTools_create_by_team_aris_css {
  width: 380px;
}
.jdLoginTools_create_by_team_aris_css .loginForm {
  position: relative;
  height: 310px;
  overflow: hidden;
}

.jdLoginTools_create_by_team_aris_css .loginForm .erp-step2-hidden-1 {
  display: none;
  width: 70px;
  position: absolute;
  top: 57px;
  bottom: 0;
  right: 0;
  background: #fff;
}
.jdLoginTools_create_by_team_aris_css .loginForm .erp-step2-hidden-2 {
  display: none;
  width: 100%;
  height: 37px;
  position: absolute;
  left: 0;
  bottom: 0;
  background: #fff;
}

.jdLoginTools_create_by_team_aris_css .loginForm .right-text-header {
  position: relative;
  font-size: 24px;
  text-align: center;
  margin-top: 40px;
  z-index: 1;
}

.jdLoginTools_create_by_team_aris_css .loginForm .login-conter {
  width: 100%;
  overflow: hidden;
  border: transparent;
}

.jdLoginTools_create_by_team_aris_css .erp {
  position: relative;
  width: 380px;
  height: 310px;
  background: #fff;
}
.jdLoginTools_create_by_team_aris_css .jdpin {
  position: relative;
  background: #fff;
}
    
.jdLoginTools_create_by_team_aris_css .erp .right-text-header {
  position: absolute;
  top: 90px;
  left: 0;
  width: 100%;
  height: 56px;
  line-height: 56px;
  margin: 0;
  background: #fff;
  text-align: center;
}

.jdLoginTools_create_by_team_aris_css .erp .login-conter {
  display:block;
  width: 300px;
  text-align:center;
  border-radius:5px;
  margin:170px auto 0 auto;
  background:#e70e0e;
  height:40px;
  line-height:40px;
  font-size:16px;
  color:#fff;
}
.jdLoginTools_create_by_team_aris_css .erp .login-conter:hover{
  background:#cf0a0a;
}

.jdLoginTools_create_by_team_aris_css .jdpin .login-conter {
  width: 100%;
  height: 210px;
  border: transparent;
  margin-top: 20px;
}

.jdLoginTools_create_by_team_aris_css .login-conter-erp-step2 .erp-step2-hidden-1{
  display: block;
}
.jdLoginTools_create_by_team_aris_css .login-conter-erp-step2 .erp-step2-hidden-2{
  display: block;
}

.jdLoginTools_create_by_team_aris_css .login-conter-erp-step3 iframe {
  height: 100%;
}
@media (-webkit-min-device-pixel-ratio: 0.11) {
  .jdLoginTools_create_by_team_aris_css .login-conter-erp-step1 iframe {
    margin-top: 57px;
    height: 503px;
  }

  .jdLoginTools_create_by_team_aris_css .login-conter-erp-step2 iframe {
    margin-top: 30px;
    height: 503px;
  }
}
@media (-webkit-min-device-pixel-ratio: 0.33) {
  .jdLoginTools_create_by_team_aris_css .login-conter-erp-step1 iframe {
    margin-top: 57px;
    height: 503px;
  }

  .jdLoginTools_create_by_team_aris_css .login-conter-erp-step2 iframe {
    margin-top: 30px;
    height: 503px;
  }
}

@media (-webkit-min-device-pixel-ratio: 0.5) {
  .jdLoginTools_create_by_team_aris_css .login-conter-erp-step1 iframe {
    margin-top: 57px;
    height: 503px;
  }

  .jdLoginTools_create_by_team_aris_css .login-conter-erp-step2 iframe {
    margin-top: 30px;
    height: 503px;
  }
}

@media (-webkit-min-device-pixel-ratio: 0.75) {
  .jdLoginTools_create_by_team_aris_css .login-conter-erp-step1 iframe {
    margin-top: 57px;
    height: 503px;
  }

  .jdLoginTools_create_by_team_aris_css .login-conter-erp-step2 iframe {
    margin-top: 30px;
    height: 503px;
  }
}

@media (-webkit-min-device-pixel-ratio: 1) {
  .jdLoginTools_create_by_team_aris_css .login-conter-erp-step1 iframe {
    margin-top: -63px;
    height: 503px;
  }

  .jdLoginTools_create_by_team_aris_css .login-conter-erp-step2 iframe {
    margin-top: 31px;
    height: 503px;
  }
}

@media (-webkit-min-device-pixel-ratio: 1.25) {
  .jdLoginTools_create_by_team_aris_css .login-conter-erp-step1 iframe {
    margin-top: 0;
  }

  .jdLoginTools_create_by_team_aris_css .login-conter-erp-step2 iframe {
    margin-top: 30px;
  }
}

@media (-webkit-min-device-pixel-ratio: 1.5) {
  .jdLoginTools_create_by_team_aris_css .login-conter-erp-step1 iframe {
    margin-top: 47px;
  }

  .jdLoginTools_create_by_team_aris_css .login-conter-erp-step2 iframe {
    margin-top: 30px;
  }
}

@media screen and (-ms-high-contrast: active),
(-ms-high-contrast: none) {
  .jdLoginTools_create_by_team_aris_css .login-conter-erp-step1 iframe {
    margin-top: -43px;
    height: 485px;
  }

  .jdLoginTools_create_by_team_aris_css .login-conter-erp-step2 iframe {
    margin-top: 30px;
    height: 485px;
  }
}

.jdLoginTools_create_by_team_aris_css .loginForm_fix_nodisplay_bug {
  width: 101%;
  visibility: hidden;
}

.jdLoginTools_create_by_team_aris_css .switchLoginType {
  margin-top: 10px;
  text-align: center;
  line-height: 23px;
  font-size: 14px;
  padding: 8px 0;
  background: #D9D9D9;
  color: #333;
}

.jdLoginTools_create_by_team_aris_css .switchLoginType a {
  color: #365EDA;
}

.jdLoginTools_create_by_team_aris_css .switchLoginType a:hover {
  text-decoration: underline;
}`;

})();

/*! @websanova/url - v2.6.3 - 2020-01-25 */
!function(){function t(t,r){var a,o={};if("tld?"!==t){if(r=r||window.location.toString(),!t)return r;if(t=t.toString(),a=r.match(/^mailto:([^\/].+)/))o.protocol="mailto",o.email=a[1];else{if((a=r.match(/(.*?)\/#\!(.*)/))&&(r=a[1]+a[2]),(a=r.match(/(.*?)#(.*)/))&&(o.hash=a[2],r=a[1]),o.hash&&t.match(/^#/))return h(t,o.hash);if((a=r.match(/(.*?)\?(.*)/))&&(o.query=a[2],r=a[1]),o.query&&t.match(/^\?/))return h(t,o.query);if((a=r.match(/(.*?)\:?\/\/(.*)/))&&(o.protocol=a[1].toLowerCase(),r=a[2]),(a=r.match(/(.*?)(\/.*)/))&&(o.path=a[2],r=a[1]),o.path=(o.path||"").replace(/^([^\/])/,"/$1"),t.match(/^[\-0-9]+$/)&&(t=t.replace(/^([^\/])/,"/$1")),t.match(/^\//))return e(t,o.path.substring(1));if((a=(a=e("/-1",o.path.substring(1)))&&a.match(/(.*?)\.([^.]+)$/))&&(o.file=a[0],o.filename=a[1],o.fileext=a[2]),(a=r.match(/(.*)\:([0-9]+)$/))&&(o.port=a[2],r=a[1]),(a=r.match(/(.*?)@(.*)/))&&(o.auth=a[1],r=a[2]),o.auth&&(a=o.auth.match(/(.*)\:(.*)/),o.user=a?a[1]:o.auth,o.pass=a?a[2]:void 0),o.hostname=r.toLowerCase(),"."===t.charAt(0))return e(t,o.hostname);o.port=o.port||("https"===o.protocol?"443":"80"),o.protocol=o.protocol||("443"===o.port?"https":"http")}return t in o?o[t]:"{}"===t?o:void 0}}function e(t,r){var a=t.charAt(0),o=r.split(a);return a===t?o:o[(t=parseInt(t.substring(1),10))<0?o.length+t:t-1]}function h(t,r){for(var a,o=t.charAt(0),e=r.split("&"),h=[],n={},c=[],i=t.substring(1),p=0,u=e.length;p<u;p++)if(""!==(h=(h=e[p].match(/(.*?)=(.*)/))||[e[p],e[p],""])[1].replace(/\s/g,"")){if(h[2]=(a=h[2]||"",decodeURIComponent(a.replace(/\+/g," "))),i===h[1])return h[2];(c=h[1].match(/(.*)\[([0-9]+)\]/))?(n[c[1]]=n[c[1]]||[],n[c[1]][c[2]]=h[2]):n[h[1]]=h[2]}return o===t?n:n[i]}window.url=t}();